import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

interface Props {
  active: boolean;
  completed: boolean;
  icon: React.ComponentType;
}

export const InsuranceStepIcon = ({ icon: Icon, active, completed }: Props) => {
  const classes = useStyles();

  return (
    <Box
      className={clsx(classes.root, {
        [classes.active]: active || completed,
      })}
    >
      <Icon />
    </Box>
  );
};

const useStyles = makeStyles({
  root: {
    backgroundColor: '#E8EAF6',
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundColor: '#2196F3',
    fontWeight: 'bold',
  },
});
